// extracted by mini-css-extract-plugin
export default {"content":"Logout_content__AASmB"};